import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../../LanguageProvider";
import SHAnnouncementDetailPage from "../SHAnnouncementDetailPage/SHAnnouncementDetailPage";
import UserSearchInput from "../../../ProjectsWindow/components/ProjectAuthorization/components/UserSearchInput";
import DatePicker from "../../../../components/DatePicker/DatePicker";
import { VscClearAll } from "react-icons/vsc";
import SHAnnouncementCard from "../../components/SHAnnouncementCard/SHAnnouncementCard";
import AddAnnouncementModal from "../../components/AddAnnouncementModal/AddAnnouncementModal";
import Services from "../../../../services/Services";

export default function SocialHiveAnnouncements({
  selectedAnnouncement,
  setSelectedAnnouncement,
  activeChannel,
}) {
  const { getTranslation } = useLanguage();
  const token = localStorage.getItem("token");

  // 1. announcementsDummy yerine API’den gelen listeyi tutacak state
  const [announcements, setAnnouncements] = useState([]);
  const [filteredAnnouncements, setFilteredAnnouncements] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  // Bir duyuruyu seçince detay sayfasını göstermek için
  const handleAnnouncementSelect = (announcement) =>
    setSelectedAnnouncement(announcement);

  // 2. API’dan çekilen veriyi state’e atıyoruz
  const fetchAnnouncements = async () => {
    try {
      const res = await Services.SocialHiveGetAnnouncements(
        token,
        activeChannel.channelID
      );
      // API’nin döndürdüğü array res.data => örneğin res.data.result kısmındaysa ona göre düzenleyin
      const apiList = res.data?.result || [];
      setAnnouncements(apiList);
    } catch (error) {
      console.error("Duyurular çekilirken hata:", error);
    }
  };

  // 3. announcements, searchQuery, startDate veya endDate değiştiğinde filtre uygula
  const filterAnnouncements = () => {
    const filtered = announcements.filter((ann) => {
      // — Arama filtresi: title veya description içinde arayabilirsiniz, şu örnekte sadece title üzerinden yapıldı:
      const matchesSearch = searchQuery
        ? ann.title.toLowerCase().includes(searchQuery.toLowerCase())
        : true;

      // — Tarih filtresi: createdDateTime Unix timestamp (saniye) => milisaniyeye çevirip Date nesnesi oluşturuyoruz
      const announcementTimestamp = Number(ann.createdDateTime) * 1000;
      const announcementsDate = new Date(announcementTimestamp);

      const matchesStart = startDate ? announcementsDate >= startDate : true;
      const matchesEnd = endDate ? announcementsDate <= endDate : true;

      return matchesSearch && matchesStart && matchesEnd;
    });

    setFilteredAnnouncements(filtered);
  };

  // İlk render ve activeChannel değişince API çağrısı
  useEffect(() => {
    if (activeChannel?.channelID) {
      fetchAnnouncements();
    }
  }, [activeChannel]);

  // announcements, searchQuery, startDate veya endDate değiştikçe filtreyi tetikle
  useEffect(() => {
    filterAnnouncements();
  }, [announcements, searchQuery, startDate, endDate]);

  // Arama inputu değiştiğinde çağrılan fonksiyon
  const handleSearch = (value) => {
    setSearchQuery(value);
  };

  const handleStartDateChange = (value) => setStartDate(value);
  const handleEndDateChange = (value) => setEndDate(value);

  const handleClear = () => {
    setSearchQuery("");
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <div className="social-hive-pages-main" style={{ paddingTop: 0 }}>
      {selectedAnnouncement ? (
        <SHAnnouncementDetailPage
          announcement={selectedAnnouncement}
          setSelectedAnnouncement={setSelectedAnnouncement}
        />
      ) : (
        <>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              position: "sticky",
              top: 0,
              backgroundColor: "inherit",
              zIndex: 99,
              marginLeft: "-2px",
              marginBottom: "2px",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <UserSearchInput
              style={{ marginBottom: "21px", height: "15px" }}
              placeholder={getTranslation("search")}
              onSearch={handleSearch}
              value={searchQuery}
            />

            <DatePicker
              key={`startDate-${startDate?.toISOString() || "none"}`}
              buttonStyle={{ width: "132px", height: "38px" }}
              initialDate={startDate}
              onDateSelect={handleStartDateChange}
              toggleLabel={getTranslation("startDate")}
            />

            <DatePicker
              key={`endDate-${endDate?.toISOString() || "none"}`}
              buttonStyle={{ width: "132px", height: "38px" }}
              initialDate={endDate}
              onDateSelect={handleEndDateChange}
              toggleLabel={getTranslation("endDate")}
            />

            <span
              style={{
                color: "var(--sh-chat-message-font-color)",
                cursor: "var(--pointer)",
              }}
              onClick={handleClear}
            >
              <VscClearAll size={23} />
            </span>

            {activeChannel.isAdmin === "1" && (
              <button
                onClick={() => setIsAddModalOpen(true)}
                className="sh-settings-action-button"
                style={{
                  marginTop: 0,
                  alignSelf: "auto",
                  height: "38px",
                  maxHeight: "38px",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingInline: "5px",
                  fontSize: "11px",
                }}
              >
                {getTranslation("createAnnouncement")}
              </button>
            )}
          </div>

          <div className="social-hive-grid">
            {filteredAnnouncements.map((ann) => {
              // createdDateTime’ı uygun bir biçime çevirebilirsiniz.
              // Örnek olarak: sadece “YYYY-MM-DD” formatı almak isterseniz:
              const dateObj = new Date(Number(ann.createdDateTime) * 1000);
              const formattedDate = dateObj.toLocaleDateString("tr-TR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              });

              return (
                <SHAnnouncementCard
                  key={ann.id}
                  imageSrc={ann.image} // API’den gelen “image” alanı
                  description={ann.description} // API’den gelen “description”
                  title={ann.title} // API’den gelen “title”
                  type={ann.type} // API’den gelen “type”
                  date={formattedDate} // Oluşturduğumuz insan okunur tarih
                  subtitle={ann.subTitle} // API’den gelen “subTitle”
                  creator={ann.createdBy.name + " " + ann.createdBy.lastname} // API’den gelen “createdBy”
                  onClick={() => handleAnnouncementSelect(ann)}
                />
              );
            })}
          </div>

          <AddAnnouncementModal
            fetchAnnouncements={fetchAnnouncements}
            selectedChannel={activeChannel}
            isOpen={isAddModalOpen}
            onClose={() => setIsAddModalOpen(false)}
          />
        </>
      )}
    </div>
  );
}
